import { NgModule } from '@angular/core';
import { ProductImageZoomComponentsModule } from '@spartacus/product/image-zoom/components';

@NgModule({
  imports: [ProductImageZoomComponentsModule],
})
export class ProductImageZoomModule {}
